"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SaasAnalyticsEvents = exports.OnlineChannelsAnalyticsEvents = void 0;
var OnlineChannelsAnalyticsEvents;
(function (OnlineChannelsAnalyticsEvents) {
    OnlineChannelsAnalyticsEvents["COPY_OWNER_CONTACT"] = "COPY__TO_CLIPBOARD";
    OnlineChannelsAnalyticsEvents["PRODUCTS_FILTER_CHANGE"] = "ITEMS__ORDER";
    OnlineChannelsAnalyticsEvents["PRODUCTS_SEARCH_CHANGE"] = "ITEMS__SEARCH";
    OnlineChannelsAnalyticsEvents["UPDATE_ITEM_QUANTITY"] = "UPDATE__ITEM_QUANTITY";
    OnlineChannelsAnalyticsEvents["CLEAR_BASKET"] = "CLEAR__BASKET";
    OnlineChannelsAnalyticsEvents["SET_DATES"] = "SET__DATES";
    OnlineChannelsAnalyticsEvents["NEW_BASKET"] = "NEW__BASKET";
    OnlineChannelsAnalyticsEvents["UPDATE_BASKET"] = "UPDATE__BASKET";
    OnlineChannelsAnalyticsEvents["CHECK_AVAILABILITY"] = "CHECK__AVAILABILITY";
    OnlineChannelsAnalyticsEvents["LEAD_GENERATED_ATTEMPT"] = "LEAD__GENERATED__ATTEMPT";
    OnlineChannelsAnalyticsEvents["LEAD_GENERATED_SUCCESS"] = "LEAD__GENERATED__SUCCESS";
    OnlineChannelsAnalyticsEvents["VIEW_FULL_SCHEDULE"] = "VIEW__FULL__SCHEDULE";
    OnlineChannelsAnalyticsEvents["SELECT_ADDRESS"] = "SELECT__ADDRESS";
    OnlineChannelsAnalyticsEvents["BUSINESS__TERMS_VIEWED"] = "BUSINESS__TERMS_VIEWED";
})(OnlineChannelsAnalyticsEvents = exports.OnlineChannelsAnalyticsEvents || (exports.OnlineChannelsAnalyticsEvents = {}));
var SaasAnalyticsEvents;
(function (SaasAnalyticsEvents) {
    SaasAnalyticsEvents["OPEN_FOR_BUSINESS"] = "SWITCH_OPEN_FOR_BUSINESS";
    SaasAnalyticsEvents["SET_OPERATING_HOURS"] = "SET_OPERATING_HOURS";
    SaasAnalyticsEvents["CHANGE_DAY_SCHEDULE"] = "CHANGE_DAY_SCHEDULE";
    SaasAnalyticsEvents["CHECK_CUSTOM_SCHEDULE_DAY"] = "CHECK_CUSTOM_SCHEDULE_DAY";
    SaasAnalyticsEvents["GENERATE_ITEM_AI"] = "ITEM__AIGEN_CLICK";
    SaasAnalyticsEvents["IMGS_NEWAI_CLICK"] = "ITEM__IMGS_NEWAI_CLICK";
    SaasAnalyticsEvents["IMGS_UPLOAD_CLICK"] = "ITEM__IMGS_UPLOAD_CLICK";
    SaasAnalyticsEvents["IMGS_DELETE_CLICK"] = "ITEM__IMGS_DELETE_CLICK";
    SaasAnalyticsEvents["DESCRIPTION_EDITED"] = "ITEM__DESCRIPTION_EDITED";
    SaasAnalyticsEvents["CATEGORY_EDITED"] = "ITEM__CATEGORY_EDITED";
    SaasAnalyticsEvents["BUSINESS__TERMS_CHANGED"] = "BUSINESS__TERMS_CHANGED";
})(SaasAnalyticsEvents = exports.SaasAnalyticsEvents || (exports.SaasAnalyticsEvents = {}));
//# sourceMappingURL=enums.js.map